<template>
  <div>
    <ul class="messages" id="messagesList">
      <chat-message
        v-for="(message, index) in messages"
        :key="message.id"
        :message="message"
        :employerData="employerData"
        :section="isSectionMessage(index, messages, message)"
      />

      <li v-show="messages.length === 0" class="pl-container-chat-log-empty">Начните общение в этом чате</li>
    </ul>
  </div>
</template>

<script>
import ChatMessage from '@/components/Chat/ChatMessage.vue'

export default {
  props: {
    messages: Array,
    employerData: Object,
  },
  components: {
    ChatMessage,
  },
  methods: {
    isSectionMessage(index, messages, message) {
      return index !== 0 ? messages[index - 1].employer.id !== message.employer.id : true
    },
  },
  watch: {
    messages() {
      if (this.messages.length >= 1) {
        this.$nextTick(() => {
          const messagesList = document.getElementById('messagesList')

          messagesList.scrollTo(0, messagesList.scrollHeight)
        })
      }
    },
  },
}
</script>
